import React, { Component } from 'react';
import { Oval } from 'react-loader-spinner';
import {
  CercaContainer,
  CercaWrapper,
  CercaHeader,
  CercaTitle,
  CercaCloseBtn,
  CercaFooter,
  SeparatorRow,
  CercaCloseBtnIcon,
  CercaBody,
  CercaBodyWrapper,
  CercaFooterWrapper,
  BtnCercaAsistida,
  LinkCercaAsistida,
  BtnCercaAsistidaWrapper,
  CercaTitleWrapper,
  CercaTitleContainer,
  TitolCercaBody,
  DescripcioCercaBody,
  TitolCercaBodyWrapper,
  TornarAlMapaButton,
  SpinnerContainer
} from './CercaElement';
import { cercaObj as Data } from './Data';
import TaulaResultatsCerca from './TaulesCerca/TaulaResultatsCerca';
import { getTranslatedKey } from '../Utils/TranslateUtils';
import { displayComponents } from '../Utils/VisorsUtils';

export default class Cerca extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 'capes', // variable de estado que indica la pestaña en la que estamos
      page: 0, // variable de estado de la pàgina donde estamos
      rowsPerPage: 10 // variable de estado de las filas (capas) por pagina
    };
    this.resizeTableRows = this.resizeTableRows.bind(this);
  }

  /**
   * @desc cuando se monta el componente, se definen las filas de la tabla
   */
  componentDidMount = () => {
    window.addEventListener('resize', this.resizeTableRows);
    this.resizeTableRows();
    if (!displayComponents.cercaLayers && !displayComponents.cercaFeatures) return this.handleTabClick('localitzacions');
    if (!displayComponents.cercaLayers) return this.handleTabClick('elements');
  };

  componentDidUpdate = async (prevProps) => {
    if (prevProps.apiTab !== this.props.apiTab && this.props.apiTab) {
      await this.props.toggleAutoTab(false);
      this.handleChangeTab(this.props.apiTab);
    }
    if (this.state.tab === 'capes' && prevProps.arCapesCataleg !== this.props.arCapesCataleg) {
      this.setState({ page: 0 });
    }
    if (this.state.tab === 'elements' && prevProps.arSolr !== this.props.arSolr) {
      this.setState({ page: 0 });
    }
    if (this.state.tab === 'localitzacions' && prevProps.arElements !== this.props.arElements) {
      this.setState({ page: 0 });
    }
  };

  UNSAFE_componentWillReceiveProps = (newProps) => {
    this.tabSelector();
  };

  /**
   * @desc mètode a executar quan el component es destrueix o es desmonta al DOM
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeTableRows);
  }

  /**
   * @desc Función encargada de calcular la cantidad de elementos que se verán en la tabla de resultados de la cerca según las medidas del navegador
   */
  resizeTableRows = () => {
    if (window.innerWidth <= 464) {
      let tableHeigth = window.innerHeight - 80 - 50 - 100 - 52 - 70;
      let rows = Math.trunc(tableHeigth / 45) - 1;
      this.setState({ rowsPerPage: rows });
    } else if (window.innerWidth <= 768) {
      let tableHeigth = 80 + 50 + 100 + 2 + 62;
      tableHeigth = window.innerHeight - tableHeigth;
      let rows = Math.round(Math.floor(tableHeigth - 52) / (45 + 5));
      this.setState({ rowsPerPage: rows });
    } else {
      let air = window.innerHeight * 0.25;
      let tableHeigth = 40 + 45 + 120 + 70 + air;
      tableHeigth = window.innerHeight - tableHeigth;
      let rows = Math.round(Math.floor(tableHeigth - 52) / (45 + 5));
      this.setState({ rowsPerPage: rows });
    }
    if (window.innerHeight < 400) {
      this.setState({ rowsPerPage: 3 });
    }
  };

  /**
   *
   * @param {*} tab
   * @desc Función encargada de cambiar la tabla a mostrar (Capas, Elementos o localizaciones)
   */
  handleChangeTab = (tab) => {
    let goTo = tab === 'capes' ? 'CapesTitle' : tab === 'elements' ? 'ElementsTitle' : 'LocationsTitle';
    let element = document.getElementById(goTo);
    switch (tab) {
      case 'capes':
        this.setState({ tab: 'capes' });
        element.scrollIntoView(false);
        break;
      case 'elements':
        this.setState({ tab: 'elements' });
        element.scrollIntoView(false);
        break;
      case 'localitzacions':
        this.setState({ tab: 'localitzacions' });
        element.scrollIntoView(false);
        break;
      default:
        break;
    }
  };

  /**
   * @param {*} event
   * @param {*} newPage
   * @desc Función encargada de cambiar la pagina activa
   */
  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  /**
   * @param {*} event
   * @desc
   */
  handleSelectChange = (event) => {
    const {
      target: { value }
    } = event;
    this.setState({
      tipologiesSelecionades: typeof value === 'string' ? value.split(',') : value
    });
  };

  /**
   * @desc Función encargada de hacer una busqueda en el Hipermapa.
   * Si los datos introducidos son coordenadas, se hará zoom a estas.
   * Sino, se hará una busqueda de las capas y elementos
   */
  // static getDeriveredStateFromProps(props, state) {
  //   if (props.isOpen) this.cerca();
  // }

  /**
   * @desc Función encargada de decidir la pestaña de la búsqueda que se muestra dependiendo de los resultados
   */
  tabSelector = () => {
    if (this.props.autoTab) {
      if (this.props.arCapesCataleg.length !== 0) {
        this.handleChangeTab('capes');
      } else if (this.props.arSolr.length !== 0) {
        this.handleChangeTab('elements');
      } else if (this.props.arElements.length !== 0) {
        this.handleChangeTab('localitzacions');
      }
    }
  };

  handleTabClick = async (capa) => {
    await this.props.toggleAutoTab(false);
    this.handleChangeTab(capa);
  };

  render() {
    return (
      <>
        <CercaContainer cercaHeight={this.props.cercaHeight} isOpen={this.props.isOpen} id="cerca-container">
          <CercaWrapper id="cerca-wrapper">
            <CercaHeader id="CercaHeader">
              <CercaTitleContainer>
                <CercaTitleWrapper id="CercaTitleHeader">
                  {displayComponents.cercaLayers && (
                    <CercaTitle
                      id="CapesTitle"
                      selected={this.state.tab === 'capes'}
                      isElements={false}
                      onClick={() => this.handleTabClick('capes')}
                      title={getTranslatedKey('resultatsCapes')}
                      fontSizeEnabled={this.props.fontSizeEnabled}>
                      {`${getTranslatedKey('selectCapesText')} (`}
                      {this.props.isLoadingCapa ? (
                        <Oval
                          height={18}
                          width={18}
                          color="#ccc"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={true}
                          ariaLabel="oval-loading"
                          secondaryColor="#eee"
                          strokeWidth={5}
                          strokeWidthSecondary={5}
                        />
                      ) : (
                        `${this.props.arCapesCataleg.length}`
                      )}
                      {')'}
                    </CercaTitle>
                  )}
                  {displayComponents.cercaFeatures && (
                    <CercaTitle
                      id="ElementsTitle"
                      selected={this.state.tab === 'elements'}
                      isElements={true}
                      onClick={() => this.handleTabClick('elements')}
                      title={getTranslatedKey('resultatsElements')}
                      fontSizeEnabled={this.props.fontSizeEnabled}>
                      {`${getTranslatedKey('selectSolrText')} (`}
                      {this.props.isLoadingEle ? (
                        <Oval
                          height={18}
                          width={18}
                          color="#ccc"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={true}
                          ariaLabel="oval-loading"
                          secondaryColor="#eee"
                          strokeWidth={5}
                          strokeWidthSecondary={5}
                        />
                      ) : (
                        `${this.props.arSolr.length}`
                      )}
                      {')'}
                    </CercaTitle>
                  )}
                  {displayComponents.cercaPlaces && (
                    <CercaTitle
                      id="LocationsTitle"
                      selected={this.state.tab === 'localitzacions'}
                      isElements={true}
                      onClick={() => this.handleTabClick('localitzacions')}
                      title={getTranslatedKey('resultatsLocalitzacions')}
                      fontSizeEnabled={this.props.fontSizeEnabled}>
                      {`${getTranslatedKey('selectElementsText')} (`}
                      {this.props.isLoadingLoc ? (
                        <Oval
                          height={18}
                          width={18}
                          color="#ccc"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={true}
                          ariaLabel="oval-loading"
                          secondaryColor="#eee"
                          strokeWidth={5}
                          strokeWidthSecondary={5}
                        />
                      ) : (
                        `${this.props.arElements.length}`
                      )}
                      {')'}
                    </CercaTitle>
                  )}
                </CercaTitleWrapper>
              </CercaTitleContainer>
              <CercaCloseBtn title={getTranslatedKey('tancarCerca')} id="CercaCloseBtn" onClick={() => this.props.onClickCloseCerca()}>
                <CercaCloseBtnIcon
                  id="CercaCloseBtnIcon"
                  src={Data.closeIcon}
                  alt={getTranslatedKey('tancarCerca')}
                  fontSizeEnabled={this.props.fontSizeEnabled}></CercaCloseBtnIcon>
              </CercaCloseBtn>
            </CercaHeader>

            <SeparatorRow id="SeparatorRowHeaderCerca" />

            <CercaBody id="CercaBody">
              <CercaBodyWrapper id="CercaBodyWrapper">
                <TitolCercaBodyWrapper id="TitleCercaWrapper">
                  <TitolCercaBody id="TitolCercaBody" fontSizeEnabled={this.props.fontSizeEnabled}>
                    {this.state.tab === 'capes'
                      ? getTranslatedKey('titolTaulaCapes')
                      : this.state.tab === 'elements'
                      ? getTranslatedKey('titolTaulaSolr')
                      : getTranslatedKey('titolTaulaElements')}
                  </TitolCercaBody>
                  <DescripcioCercaBody id="DescCercaBody" fontSizeEnabled={this.props.fontSizeEnabled}>
                    {this.state.tab === 'capes'
                      ? getTranslatedKey('descripcioTaulaCapes')
                      : this.state.tab === 'elements'
                      ? getTranslatedKey('descripcioTaulaSolr')
                      : getTranslatedKey('descripcioTaulaElements')}
                  </DescripcioCercaBody>
                </TitolCercaBodyWrapper>
                {/*<FiltresWrapper id="FiltresWrapper" title={getTranslatedKey('selectorFiltres')}>
                  <FiltresLabel>{getTranslatedKey('filtres')}</FiltresLabel>
                  <SelectWrapper id="SelectWrapper">
                    <FiltresSelect options={tipologies} id="FiltresSelect"></FiltresSelect>
                  </SelectWrapper>
                </FiltresWrapper> */}
                {(this.state.tab === 'capes' && !this.props.isLoadingCapa) ||
                (this.state.tab === 'localitzacions' && !this.props.isLoadingLoc) ||
                (this.state.tab === 'elements' && !this.props.isLoadingEle) ? (
                  <TaulaResultatsCerca
                    id="TaulaResultatsCerca"
                    infoPuntObert={this.state.infoPuntObert}
                    isCapes={this.state.tab}
                    elementsList={
                      this.state.tab === 'capes'
                        ? this.props.arCapesCataleg
                        : this.state.tab === 'elements'
                        ? this.props.arSolr
                        : this.props.arElements
                    }
                    page={this.state.page}
                    rowsPerPage={this.state.rowsPerPage}
                    totalRows={
                      this.state.tab === 'capes'
                        ? this.props.arCapesCataleg.length
                        : this.state.tab === 'elements'
                        ? this.props.arSolr.length
                        : this.props.arElements.length
                    }
                    handleChangePage={(event, newPage) => this.handleChangePage(event, newPage)}
                    onClickElementCerca={(coords, isGeolocalitzacio, isETRS, isElement, id, name) =>
                      this.props.onClickElementCerca(coords, isGeolocalitzacio, isETRS, isElement, id, name)
                    }
                    sitepLayers={this.props.catalogData}
                    sitepLayerInfoMap={this.props.sitepLayerInfoMap}
                    addLayerToLlegenda={(capa) => this.props.addLayerToLlegenda(capa)}
                    fontSizeEnabled={this.props.fontSizeEnabled}></TaulaResultatsCerca>
                ) : (
                  <SpinnerContainer>
                    <Oval
                      height={window.innerHeight > 400 ? 80 : 40}
                      width={window.innerHeight > 400 ? 80 : 40}
                      color="#febf00"
                      wrapperStyle={{}}
                      wrapperClass=""
                      visible={true}
                      ariaLabel="oval-loading"
                      secondaryColor="#ccc"
                      strokeWidth={2}
                      strokeWidthSecondary={2}
                    />
                  </SpinnerContainer>
                )}
              </CercaBodyWrapper>
            </CercaBody>

            <CercaFooter id="CercaFooter">
              <SeparatorRow id="SeparatorRowCerca" />
              <CercaFooterWrapper id="CercaFooterWrapper">
                <BtnCercaAsistida id="BtnCercaAsistida" title={getTranslatedKey('cercaAvançada')}>
                  <BtnCercaAsistidaWrapper id="BtnCercaWrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      height={window.innerWidth < 464 ? '20px' : '24px'}
                      width={window.innerWidth < 464 ? '20px' : '24px'}
                      fill="#fff">
                      <path d="M9 6V8H2V6H9M9 11V13H2V11H9M18 16V18H2V16H18M19.31 11.5C19.75 10.82 20 10 20 9.11C20 6.61 18 4.61 15.5 4.61S11 6.61 11 9.11 13 13.61 15.5 13.61C16.37 13.61 17.19 13.36 17.88 12.93L21 16L22.39 14.61L19.31 11.5M15.5 11.61C14.12 11.61 13 10.5 13 9.11S14.12 6.61 15.5 6.61 18 7.73 18 9.11 16.88 11.61 15.5 11.61Z" />
                    </svg>
                  </BtnCercaAsistidaWrapper>
                </BtnCercaAsistida>
                <TornarAlMapaButton
                  title={getTranslatedKey('descripcioBoto')}
                  onClick={() => this.props.onClickCloseCerca()}
                  fontSizeEnabled={this.props.fontSizeEnabled}>
                  {getTranslatedKey('descripcioBoto')}
                </TornarAlMapaButton>
                <LinkCercaAsistida id="LinkCercaAsistida" fontSizeEnabled={this.props.fontSizeEnabled}>
                  {getTranslatedKey('cercaAsistidaText')}
                </LinkCercaAsistida>
              </CercaFooterWrapper>
            </CercaFooter>
          </CercaWrapper>
        </CercaContainer>
      </>
    );
  }
}
